<div class="spinnerWrapper" [ngClass]="[isGlobal ? '' : '!tw-relative tw-rounded-lg', wrapperClass]">
  <div class="ngxUILoaderTemplate" [ngClass]="[size, loaderClass]" *ngIf="type === 'spinner'">
    <div class="loader-circle"></div>
    <div class="loader-line-mask">
      <div class="loader-line"></div>
    </div>
    <img src="./assets/images/brand/see-my-legacy.svg" alt="SeeMyLegacy" class="" *ngIf="showImage">
  </div>

  <span class="dots-circle-spinner loading" *ngIf="type === 'dots'"></span>
</div>